import { createSlice } from '@reduxjs/toolkit';
import { DTO__collection } from '@shared/dto/collection/DTO__collection';
import { DTO__special_collections_info } from '@shared/dto/collection/DTO__special_collections_info';
import { ENUM__redux_slice } from '../_base/ENUM__redux_slice';
import { LOCAL__global_reset } from '../_base/LOCAL__global_reset';
import { init_remote_workspace_child_entity_share_status_update } from '../workspace/child_entity/remote_workspace_child_entity_share_status_update';
import { INIT_LOCAL__collection_cells_delete } from './cell/LOCAL__collection_cells_delete';
import { INIT_LOCAL__collection_cells_upsert } from './cell/LOCAL__collection_cells_upsert';
import { INIT_REMOTE__collection_cells_delete } from './cell/REMOTE__collection_cells_delete';
import { INIT_REMOTE__collection_image_add } from './cell/REMOTE__collection_image_add';
import { INIT_LOCAL__collection_delete } from './entity/local_collection_delete';
import { INIT_LOCAL__collection_set_current } from './entity/local_collection_set_current';
import { init_local_collection_set_special_collections_by_workspace_id } from './entity/local_collection_set_special_collections_by_workspace_id';
import { init_local_collection_upsert } from './entity/local_collection_upsert';
import { init_remote_collection_create } from './entity/remote_collection_create';
import { init_remote_collection_get_shared_by_id } from './entity/remote_collection_get_shared_by_id';
import { init_remote_collection_update_name } from './entity/remote_collection_update_name';
import { init_remote_collection_update_visibility } from './entity/remote_collection_update_visibility';
import { init_local_collection_special_info_set_current } from './special/local_collection_special_info_set_current';
import { init_local_collection_special_info_upsert } from './special/local_collection_special_info_upsert';
import { STATE__collections } from './STATE__collections';

export const initialStateCollections: STATE__collections = {
  collections_map: new Map(),
  custom_collections_map: new Map(),

  collection_uploads: DTO__collection.CREATE_STUB(),
  collection_viewed_on_search: DTO__collection.CREATE_STUB(),
  collection_generated: DTO__collection.CREATE_STUB(),
  collection_favorites: DTO__collection.CREATE_STUB(),

  collection_current: DTO__collection.CREATE_STUB(),

  special_collections_info_map: new Map(),
  special_collections_info_current: DTO__special_collections_info.CREATE_STUB(),
};

export const slice_collections = createSlice({
  name: ENUM__redux_slice.COLLECTION,
  initialState: initialStateCollections,
  reducers: {
    delete_cells: INIT_LOCAL__collection_cells_delete,
    upsert_cells: INIT_LOCAL__collection_cells_upsert,

    collections_set_current: INIT_LOCAL__collection_set_current,

    upsert_collection: init_local_collection_upsert,
    delete_collection: INIT_LOCAL__collection_delete,

    set_special_collections_by_workspace_id: init_local_collection_set_special_collections_by_workspace_id,

    special_info_collections_upsert: init_local_collection_special_info_upsert,

    special_info_collections_upsert_set_current: init_local_collection_special_info_set_current,
  },

  extraReducers: builder => {
    init_remote_collection_create(builder);

    init_remote_collection_update_name(builder);
    init_remote_collection_update_visibility(builder);
    init_remote_collection_get_shared_by_id(builder);
    init_remote_workspace_child_entity_share_status_update(builder);

    INIT_REMOTE__collection_image_add(builder);
    INIT_REMOTE__collection_cells_delete(builder);

    builder.addCase(LOCAL__global_reset, state => {
      return initialStateCollections;
    });
  },
});
